import domReady from '@wordpress/dom-ready';

const Tabs = () => {
	const navs = document.querySelectorAll('.ahha-tab__nav-item');
	const contents = document.querySelectorAll('.ahha-tab__content-item');

	let activeNav = null;
	let activeContent = null;

	if (navs.length > 0 && contents.length > 0) {
		activeNav = navs[0];
		activeContent = contents[0];

		activeNav.classList.add('active');
		activeContent.classList.add('active');
	}

	navs.forEach((nav, index) => {
		nav.addEventListener('click', () => {
			if (activeNav) {
				activeNav.classList.remove('active');
			}

			if (activeContent) {
				activeContent.classList.remove('active');
			}

			const content = contents[index];

			nav.classList.add('active');
			content.classList.add('active');

			activeNav = nav;
			activeContent = content;
		});
	});
};

domReady(() => {
	Tabs();
});
